export enum UserRole {
  Connector = "CONNECTOR",
  Worker = "WORKER",
  Employer = "EMPLOYER",
}
